import { useStores } from '../api/queries.js';
import { useAuthStore } from '../auth/auth-store.js';

import { Field, Select } from './ui/index.js';

/**
 * Магазин канала или виджета.
 *
 * Пришедшее с платформы (площадка магазина, чат на витрине) привязано к
 * магазину самой платформой — показываем, но менять не даём, иначе две
 * службы разошлись бы. Выбирать магазин можно только для заведённого прямо
 * здесь (свой бот, своя почта). Пустое значение — «общий для всех
 * магазинов». Пока магазинов нет — поле не показывается.
 */
export function StoreSelect({
  value,
  onChange,
  hint,
  locked,
}: {
  value: string | null;
  onChange: (storeId: string | null) => void;
  hint?: string;
  /** Привязку задаёт платформа — только показать */
  locked?: boolean;
}): JSX.Element | null {
  const slug = useAuthStore((s) => s.user?.workspaceSlug);
  const stores = (useStores(slug).data ?? []).filter((s) => s.is_active || s.id === value);
  if (stores.length === 0) return null;
  if (locked) {
    const name = stores.find((s) => s.id === value)?.name ?? 'Общий для всех магазинов';
    return (
      <Field label="Магазин" hint="Привязку задаёт платформа магазина — меняется вместе с ней.">
        <div>{name}</div>
      </Field>
    );
  }
  return (
    <Field label="Магазин" hint={hint ?? 'Диалоги отсюда попадут во вкладку этого магазина, а заказы и товары будут браться из него.'}>
      <Select value={value ?? ''} onChange={(e) => onChange(e.target.value || null)}>
        <option value="">Общий для всех магазинов</option>
        {stores.map((s) => (
          <option key={s.id} value={s.id}>
            {s.name}
          </option>
        ))}
      </Select>
    </Field>
  );
}
